import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ProgramListItemActionButtonConfiguration } from '@shared/components/program-list-item/program-list-item.component';
import { Learnspace, ProgramTemplate } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';

@Component({
  selector: 'program-template-preview-dialog',
  templateUrl: './program-template-preview-dialog.component.html',
  styleUrls: ['./program-template-preview-dialog.component.scss']
})
export class ProgramTemplatePreviewDialogComponent implements OnInit {
  template: ProgramTemplate;
  program?: Learnspace;
  actionButtons?: ProgramListItemActionButtonConfiguration[];
  
  constructor(
    private _courseApiService: CoursesAPIService,
    @Inject(MAT_DIALOG_DATA) private _data: { template: ProgramTemplate, actionButtons?: ProgramListItemActionButtonConfiguration[]}
  ) {
    this.template = this._data.template;
    this.actionButtons = this._data.actionButtons;
  }

  async ngOnInit(): Promise<void> {
    this._courseApiService.getLearnspaceById(this.template.program_id, true).subscribe((program: Learnspace) => {
      this.program = program;
      program.courses?.sort((a, b) => a.position - b.position);
    });
  }
}
